// import useLeads from "../hooks/useLeads";

export const sidebarNav = [

  // NEW LEAD
  {
    label: "New Lead",
    path: "/leads/new",
    roles: ["admin", "agent"],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
      </svg>
    ),
  },

  {
    label: "Dashboard",
    path: "/dashboard",
    roles: ["admin", "agent", "quality"],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 13h8V3H3v10zm10 8h8V11h-8v10zM3 21h8v-6H3v6zm10-10h8V3h-8v8z"
        />
      </svg>
    ),
  },
  // LEADS
  {
    label: "Leads",
    path: "/leadslist",
    roles: ["admin", "agent"],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8 7V3m8 4V3m-9 8h10m-11 8h12a2 2 0 002-2V7a2 2 0 00-2-2H6a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
      </svg>
    ),
  },

  // DASHBOARD
  

  // CALLBACK
  {
    label: "Callback",
    path: "/callback-leads",
      countKey: "callback", 
    roles: ["admin", "agent"],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 10h11M9 21V3m12 4l-4 4 4 4"
        />
      </svg>
    ),
  },

  // REJECTS
  {
    label: "Rejects",
    path: "/rejects",
    countKey: "reject",
    roles: ["admin", "quality","agent"],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M18.364 5.636l-12.728 12.728M6 6l12 12"
        />
      </svg>
    ),
  },

  // HOLD
  {
    label: "Hold",
    path: "/hold",
     countKey: "hold",
    roles: ["admin", "quality","agent"],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M10 9v6m4-6v6M5 5h14v14H5z"
        />
      </svg>
    ),
  },

  // QUALITY
  {
    label: "Quality",
     countKey: "quality",
    roles: ["admin", "quality","agent"],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 12l2 2 4-4m5-2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),

    // children: [
    //   {
    //     label: "Quality",
    //     path: "/quality-leads",
    //   },
    //   {
    //     label: "Quality Low AQ",
    //     path: "/qualitylowaq-leads",
    //   },
    //   {
    //     label: "Quality 00",
    //     path: "/quality00-leads",
    //   },
    //   // {
    //   //   label: "Callback",
    //   //   path: "/callback-leads",
    //   // },
    // ],

     children: [
      { label: "Quality",        path: "/quality-leads",      countKey: "quality_standard" },  // ← NEW
      { label: "Quality Low AQ", path: "/qualitylowaq-leads", countKey: "quality_low_aq"   },  // ← NEW
      { label: "Quality 00",     path: "/quality00-leads",    countKey: "quality_oo"        },  // ← NEW
    ],
  },

  // VALIDATED
  {
    label: "Validated",
    countKey: "validate", 
    roles: ["admin", "quality","agent"],
    path: "/Validate",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 13l4 4L19 7"
        />
      </svg>
    ),

    // children: [
    //   {
    //     label: "Validate",
    //     path: "/validate",
    //   },
    //   {
    //     label: "Validate Low AQ",
    //     path: "/validate-low-aq",
    //   },
    //   {
    //     label: "Validate 00",
    //     path: "/validate-00",
    //   },
    // ],


    children: [
      { label: "Validate",        path: "/validate",        countKey: "validate_standard" },  // ← NEW
      { label: "Validate Low AQ", path: "/validate-low-aq", countKey: "validate_low_aq"  },  // ← NEW
      { label: "Validate 00",     path: "/validate-00",     countKey: "validate_oo"       },  // ← NEW
    ],
  },

  // ADVANCE SEARCH
  {
    label: "Advance Search",
    path: "/advance",
    roles: ["admin","agent", "quality"],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M21 21l-4.35-4.35M16 10a6 6 0 11-12 0 6 6 0 0112 0z"
        />
      </svg>
    ),
  },


{
  label: "Sold",
  path: "/sold",
  roles: ["admin", "quality"],
   countKey: "sold",
  icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-5 h-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 8h14l1 12H4L5 8z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 8V6a3 3 0 016 0v2"
      />
    </svg>
  ),
},


  // AGENTS
  {
    label: "Agents",
    path: "/agents",
    roles: ["admin"],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M17 20h5v-2a3 3 0 00-5.356-1.857M9 20H4v-2a3 3 0 015.356-1.857M15 7a3 3 0 11-6 0 3 3 0 016 0z"
        />
      </svg>
    ),
  },

  // REPORTS
  // {
  //   label: "Reports",
  //   roles: ["admin"],
  //   icon: (
  //     <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  //       <path
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //         strokeWidth={2}
  //         d="M9 17v-6m4 6V7m4 10V4M5 20h14"
  //       />
  //     </svg>
  //   ),

  //   children: [
  //     {
  //       label: "Reports",
  //       path: "/reports",
  //     },
  //     {
  //       label: "Reports Low AQ",
  //       path: "/reports-low-aq",
  //     },
  //     {
  //       label: "Reports 00",
  //       path: "/reports-00",
  //     },
  //   ],
  // },

  // CHANGE PASSWORD
  {
    label: "Change Password",
    path: "/change-password",
    roles: ["admin"],
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2h-1V9a5 5 0 00-10 0v2H6a2 2 0 00-2 2v6a2 2 0 002 2zm3-10V9a3 3 0 016 0v2H9z"
        />
      </svg>
    ),
  },

];